export const FETCHING_USER = "FETCHING.USER";
export const UPDATING_USER = "UPDATING.USER";
export const RESENDING_ACTIVATION_EMAIL = "RESENDING_ACTIVATION_EMAIL.USER";
export const UPDATED_USER = "UPDATED.USER";
export const UPDATING_USER_COMPLETE = "UPDATED.COMPLETE";
export const FETCHED_USER = "FETCHED.USER";
export const ERROR_FETCHING_USER = "ERROR.FETCHING_USER";
export const ERROR_UPDATING_USER = "ERROR.UPDATING_USER";
export const ERROR_RESET_USER_PASSWORD = "ERROR.RESET_USER_PASSWORD";
export const ERROR_ACTIVATE_ACCOUNT = "ERROR.ACTIVATE_ACCOUNT";
export const ERROR_RESENDING_ACTIVATION_EMAIL = "ERROR.RESEND_ACTIVATION_EMAIL";
